import gql from "graphql-tag";
import { useBillingInitializedBillingAccountsQuery } from "./useBillingInitialized.generated";

export const useBillingInitialized = (options?: {
  skip?: boolean;
}): boolean => {
  const { data } = useBillingInitializedBillingAccountsQuery({
    skip: options?.skip,
  });
  return !!data?.BillingAccounts && data?.BillingAccounts?.length > 0;
};

gql`
  query BillingInitializedBillingAccounts {
    BillingAccounts(input: {}) {
      id
    }
  }
`;
